<template lang="pug">
  div.pointBuy
    van-dropdown-menu(class="select_box")
      van-dropdown-item(v-model="active", :options="status")
    van-collapse(v-model="record", accordion)
      van-list(v-model="listLoading", @load="onListLoad", :loading-text="$t('loading')", :finished-text="$t('noMore')", error-text="...", :finished="finished")
        div(class="hst_box van-clearfix", v-for='(item, key) in orderList', v-if="item.status > -1", :key="key" @click="toChatPage(item)")
          van-collapse-item(class="pointBuy_list")
            template(#icon)
              img(class="pointBuy_icon", :src="item.icon")
            template(#title)
              p.title {{item.productName}}
              p.time {{formatDate(item.paySuccessTime || item.createTime, true)}}
            template(#value)
              p.status {{formatStatus(item.status)}}
            p {{$t('orderID')}}{{item.orderId}}
            p {{$t('accountUID')}}{{item.uid}}
            p {{$t('consumePoint')}}{{item.integral}}
            p(v-if='item.createTime') {{$t('orderCreationTime')}}{{formatDate(item.createTime)}}
            //- p(v-if='item.createTime') {{$t('orderPaymentTime')}}{{formatDate(item.createTime)}}
            p(v-if='item.sendTime') {{$t('orderDeliveryTime')}}{{formatDate(item.sendTime)}}
            p {{$t('gameName')}}{{item.appName}}
            p(v-if='item.serverName !== " "') {{$t('serverName')}}{{item.serverName}}
            p(v-if='item.roleName !== " "') {{$t('roleName')}}{{item.roleName}}
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import {mapActions, mapGetters} from 'vuex';
import Qs from 'qs';

export default {
  name: 'pointBuy',
  data($vm){
    return{
      active: '',
      record: '',
      orderList:[],
      pageNumber: 1,
      listLoading: false,
      finished: false,
      loadStatus: true
    }
  },
  created(){
    this.getPurchaseHi({
      uid: this.uid,
      deviceId: this.deviceId,
      accessToken: this.token,
      pageNumber: 1,
      language: this.lang
    })
  },
  methods:{
    ...mapActions('record', ['getPurchaseHi']),
    onListLoad(){
      if(this.loadStatus){
        return false
      }
      this.loadStatus = true
      this.pageNumber += 1
      this.getPurchaseHi({
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
        pageNumber: this.pageNumber,
        language: this.lang
      })
    }
  },
  computed:{
    ...mapGetters(['lang', 'uid', 'deviceId', 'token']),
    ...mapGetters('record', ['purchasing', 'purchaseHiList']),
    status: $vm => {
      return [
        {
          text: $vm.$t('all'),
          value: ''
        },
        {
          text: $vm.$t('paymentSuccess'),
          value: '0'
        },
        {
          text: $vm.$t('distributionFail'),
          value: '50'
        },
        {
          text: $vm.$t('tradeSuccess'),
          value: '100'
        }
      ]
    },
    formatDate: (val, key = false) => {
      return (val, key= false) => {
        let payDate = new Date(parseInt(val));
        if(key){
          return payDate.getFullYear() + '-' + (payDate.getMonth() + 1) + '-' + payDate.getDate() + '  ' + payDate.getHours() + ':' + payDate.getMinutes() + ':' + payDate.getSeconds() + '    ' + 'UTC+' + (0 - new Date().getTimezoneOffset() / 60);
        } else {
          return payDate.getFullYear() + '-' + (payDate.getMonth() + 1) + '-' + payDate.getDate() + '  ' + payDate.getHours() + ':' + payDate.getMinutes() + ':' + payDate.getSeconds()
        }
      }
    },
    formatStatus: ($vm) => {
      return (val) => {
        if(val === '0'){
          return $vm.$t('paymentSuccess')
        } else if(val === '50'){
          return $vm.$t('distributionFail')
        } else if(val === '100'){
          return $vm.$t('tradeSuccess')
        }
      }
    }
  },
  mounted(){
    this.$watch('purchasing', val => {
      if(val === 'purchased'){
        this.purchaseHiList.list.map(val => {
          this.orderList.push(val)
        })
        console.log(this.orderList)
        if(this.orderList.length == this.purchaseHiList.total){
          this.finished = true
        }
        this.loadStatus = false
        this.listLoading = false
      }
    })
    this.$watch('active', val => {
      this.pageNumber = 1
      this.loadStatus = true
      this.finished = false
      this.orderList = []
      this.getPurchaseHi({
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
        pageNumber: 1,
        status: val
      })
    })
  }
}
</script>
<style lang="scss">
.pointBuy{
  margin: 20px;
  .van-dropdown-menu__item{
    margin: 0 4px;
  }
  .van-dropdown-menu__title::after{
    right: 0px;
  }
  .select_box{
    width: 50%;
    position: relative;
    left: 50%;
    .van-dropdown-menu__bar{
      height: 30px;
    }
  }
  .pointBuy_list{
    margin-top: 10px;
    .van-cell__value{
      position: absolute;
      right: 40px;
      line-height: 60px;
      p{
        margin: 0;
      }
    }
    .van-cell__right-icon{
      line-height: 60px;
    }
    .van-collapse-item__content{
      p{
        margin: 0;
        padding: 5px 10px;
      }
    }
  }
  .pointBuy_icon{
    height: 60px;
    width: 60px;
    position: relative;
  }
  .title{
    margin: 0;
    font-size: 18px;
    color: #000;
    padding-left: 10px;
    font-weight: bolder;
  }
  .time{
    margin: 0;
    font-size: 12px;
    color: #969799;
    padding-left: 10px;
    margin-top: 12px;
  }
  .van-hairline--top-bottom::after{
    border-width: 0px;
  }
}
</style>